import Icon from '../components/Icon.vue'

Icon.register({
  'arrow-up': {
    width: 448,
    height: 512,
    paths: [
      {
        d: 'M34.9 289.5L12.7 267.3C3.3 257.9 3.3 242.7 12.7 233.4L207 39C216.4 29.6 231.6 29.6 240.9 39L435.2 233.3C444.6 242.7 444.6 257.9 435.2 267.2L413 289.4C403.5 298.9 388 298.7 378.7 289L264 168.6V456C264 469.3 253.3 480 240 480H208C194.7 480 184 469.3 184 456V168.6L69.2 289.1C59.9 298.9 44.4 299.1 34.9 289.5z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/arrow-up.js
// module id = FE82
// module chunks = 144